const state = {
   isMobileLayout: false,
   country: null
};

const getters = {
   country(state) {
      return state.country;
   },
   isMobileLayout(state) {
      return state.isMobileLayout;
   }
};

const mutations = {
   SET_COUNTRY(state, country) {
      state.country = country;
   },
   UPDATE_MOBILE_BROWSER_LAYOUT(state, isMobileLayout) {
      state.isMobileLayout = isMobileLayout;
   }
};

const actions = {
   updateMobileBrowserLayout: ({ commit }, isMobileLayout) => {
      commit("UPDATE_MOBILE_BROWSER_LAYOUT", isMobileLayout);
   }
};

export default {
   state,
   getters,
   mutations,
   actions
};
